import { therapyPlanningAction } from '../../actions/constant';

const {
  GET_MULTIPLE_MDS_ASSESSMENT_SUCCESS,
  GET_MULTIPLE_MDS_ASSESSMENT_FAILURE,
  GET_MULTIPLE_MDS_ASSESSMENT_LOADING,
  GET_MULTIPLE_MDS_ASSESSMENT_REQUEST,
  GET_MULTIPLE_MDS_ASSESSMENT_RESET,
} = therapyPlanningAction;

const initialState: object = {
  isError: false,
  errorMessage: '',
  response: null,
  loading: false,
};

export const getMultipleMDSAssessment = (state = initialState, action: any) => {
  switch (action.type) {
    case GET_MULTIPLE_MDS_ASSESSMENT_SUCCESS: {
      return {
        ...state,
        response: action.payload,
        isError: false,
        errorMessage: '',
        loading: false,
      };
    }

    case GET_MULTIPLE_MDS_ASSESSMENT_FAILURE:
      return {
        ...state,
        isError: true,
        errorMessage: action.payload,
        response: null,
        loading: false,
      };
    case GET_MULTIPLE_MDS_ASSESSMENT_LOADING:
      return {
        ...state,
        loading: true,
      };

    case GET_MULTIPLE_MDS_ASSESSMENT_RESET:
      return initialState;
    default:
      return state;
  }
};
